import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, Button } from "reactstrap";
import { Grid } from "@mui/material";
import { useEntitiesEP } from "../hooks";
import Table from "./table";
import Loader from "../../../Global/Loader";
import { Modal as ModalAntd } from "antd";
import createModal from "../../Components/ModalV2";

const { confirm } = ModalAntd;

const DetailModal = ({ open, toggle, entity, t, handleAssociate }) => {
  const {
    filterEntitiesEP,
    loading,
    handleFilterEntitiesEP,
    setEntityEPService,
  } = useEntitiesEP(entity.CustomerCodeEP, entity.RecordTypeId);
  const [entityEP, setEntityEP] = useState(null);
  const [disabled, setDisabled] = useState(true);
  const [messageType, setMessageType] = useState(t("associationEntities.shared.consignee"));
  const [confirmAssociate, setConfirmAssociate] = useState(false);


  useEffect(() => {
    if (entity?.EntityRelationshipId) {
      setEntityEP({
        EntityId: entity.EntityRelationshipId,
        Nombre: entity.CustomerEPName,
        Address: entity.CustomerEPAddress,
      });
    } else {
      setEntityEP(null);
    }
    if (entity?.RecordTypeId) {
      setMessageType(entity.RecordTypeId === 5 ? t("associationEntities.shared.consignee") : t("associationEntities.shared.shipper"));
    }
  }, [entity]);

  const handleClose = () => {
    handleFilterEntitiesEP("");
    toggle();
    if (entity?.EntityRelationshipId) {
      setEntityEP({
        EntityId: entity.EntityRelationshipId,
        Nombre: entity.CustomerEPName,
        Address: entity.CustomerEPAddress,
      });
    } else {
      setEntityEP(null);
    }
  };

  const handleClickRow = (value) => {
    setEntityEP({
      ...value,
      RecordTypeId: entity.RecordTypeId,
      Nombre: value.entityName,
      Address: value.address,
    });
    if (value.entityCode === entity.CodeEP) {
      setDisabled(true);
      return;
    }
    setDisabled(false);
  };

  const handleConfirmAssociate = async () => {
    try {
      if (!entityEP || entityEP.EntityId) {
        return;
      }
      handleAssociate(
        await setEntityEPService(entity.CustomerEntityId, {
          ...entityEP,
        })
      );
    } catch (error) {
      console.log(error);
      handleAssociate(false);
    }
  };

  function toggleModal() {
    setConfirmAssociate(!confirmAssociate)
  }


  // const handleClickAssociate = async () => {
  //   confirm({
  //     wrapClassName: "confirmModalEntities",
  //     title: <div className="hr-popover" />,
  //     centered: true,
  //     icon: false,
  //     cancelText: "No",
  //     okText: t("yes"),
  //     content: (
  //       <div>
  //         <div className="col-12" style={{ textAlign: "center" }}>
  //           <p class="seacargo-pop-icon">
  //             <em style={{ fontSize: '20px' }} class="fas fa-exclamation-triangle"></em>
  //           </p>
  //           <span className="colorPrimariLable">{t("associationEntities.modal.confirm")}</span>
  //         </div>
  //       </div>
  //     ),
  //     onOk: handleConfirmAssociate,
  //     onCancel() {
  //       console.log("Cancel");
  //     },
  //   });
  // };

  const columns = [
    {
      dataIndex: "entityName",
      key: "entityName",
      title: t("associationEntities.shared.epEntityName"),
      label: t("associationEntities.shared.epEntityName"),
      width: "40%",
      showAllText: true,
    },
    {
      dataIndex: "address",
      key: "address",
      title: t("associationEntities.shared.epEntityAddress"),
      label: t("associationEntities.shared.epEntityAddress"),
      width: "60%",
      showAllText: true,
    },
  ];

  return (
    <>
      <Modal
        backdrop="static"
        centered={true}
        isOpen={open}
        toggle={toggle}
        size="lg"
        // style={{ maxWidth: "1000px", width: "100%" }}
        className="listItemModal"
      >
        <ModalHeader className="advancedSearchModal detailModalHeader">
          <span className="euro-title-form">
            {t("associationEntities.modal.title", { type: messageType })}
          </span>
        </ModalHeader>
        <ModalBody className="noPaddingTop">
          <Grid container spacing={2} style={{ margin: "0.1rem" }}>
            <Grid
              xs={6}
              item
              style={{ marginTop: ".5rem", marginBottom: ".5rem" }}
            >
              <label className="label-euro bold">
                {t("associationEntities.modal.client.title")}
              </label>
              <Grid
                container
                xs={12}
                style={{ marginTop: ".5rem", marginBottom: ".5rem" }}
              >
                <Grid item xs={5}>
                  <label className="label-euro bold marginTopBottom">
                    {t("associationEntities.shared.name")}
                  </label>
                  <label className="label-euro marginTopBottom">
                    {entity.CustomerEntityName}
                  </label>
                </Grid>
                <Grid item xs={5}>
                  <label className="label-euro bold marginTopBottom">
                    {t("associationEntities.shared.address")}
                  </label>
                  <label className="label-euro marginTopBottom">
                    {entity.CustomerEntityAddress}
                  </label>
                </Grid>
              </Grid>
            </Grid>
            <Grid
              xs={6}
              item
              style={{ marginTop: ".5rem", marginBottom: ".5rem" }}
            >
              <label className="label-euro bold">
                {t("associationEntities.modal.ep.title")}
              </label>
              <Grid
                container
                xs={12}
                style={{ marginTop: ".5rem", marginBottom: ".5rem" }}
              >
                <Grid item xs={5}>
                  <label className="label-euro bold marginTopBottom">
                    {t("associationEntities.shared.name")}
                  </label>
                  <label className="label-euro marginTopBottom">
                    {entityEP?.Nombre}
                  </label>
                </Grid>
                <Grid item xs={5}>
                  <label className="label-euro bold marginTopBottom">
                    {t("associationEntities.shared.address")}
                  </label>
                  <label className="label-euro marginTopBottom">
                    {entityEP?.Address}
                  </label>
                </Grid>
              </Grid>
              <Grid container style={{ marginTop: "4rem", gap: "2rem" }}>
                <Button
                  className="custom-width-btn"
                  color="secondary"
                  onClick={handleClose}>
                  {t("associationEntities.shared.cancel")}
                </Button>
                <Button
                  color="primary"
                  className="custom-width-btn"
                  disabled={loading || disabled}
                  onClick={toggleModal}
                >
                  {t("associationEntities.shared.associate")}
                </Button>
              </Grid>
            </Grid>
            <Grid
              xs={12}
              item
              style={{ marginTop: ".5rem", marginBottom: ".5rem" }}
              className="gridTable"
            >
              <Table
                columns={columns}
                data={loading ? [] : filterEntitiesEP}
                loading={loading}
                handleClickRow={handleClickRow}
                handleSearch={handleFilterEntitiesEP}
                showSearch={true}
                placeholderSearch={t("associationEntities.shared.search")}
              />
            </Grid>
          </Grid>
        </ModalBody>
      </Modal>
      {createModal({
        isModalOpen: confirmAssociate,
        component: (
          <>
            <div className="col-12" style={{ textAlign: "center" }}>
              <p>{t("associationEntities.modal.confirm")}</p>
            </div>
          </>
        ),
        buttons: [
          {
            text: t("po_management_detail_button_no"),
            onClick: toggleModal,
            type: "secondary",
          },
          {
            text: t("po_management_detail_button_yes"),
            onClick: handleConfirmAssociate,
            type: "primary",
          },
        ],
        onCancel: toggleModal
      })}
    </>
  );
};

export default DetailModal;
